import { Link } from "react-router-dom";
import SEOMeta from "@/components/SEOMeta";
import NavbarNew from "@/components/NavbarNew";
import FooterNew from "@/components/FooterNew";
import { PillarCards } from "@/components/automacao/PillarCards";
import {
  AutomacaoFaqSection,
  AutomacaoPricingSection,
  AutomacaoStepsSection,
} from "@/components/automacao/AutomacaoSections";
import { Photo } from "@/components/shared/Photo";

const container = "mx-auto max-w-[1180px] px-8 max-[900px]:px-5";

/**
 * Hub /automacao-empresarial: apresenta a frente de automação e leva aos
 * pilares visíveis. Página inteira (Navbar + Footer). Não captura lead
 * direto — o CTA vai para /contato; o formulário por pilar fica em
 * `ProductPageTemplate`.
 */
const AutomacaoHub = () => (
  <div className="min-h-screen bg-background">
    <SEOMeta
      title="Automação com IA para PMEs — CRM e atendimento"
      description="CRM com follow-up automático e atendimento com IA no WhatsApp, Instagram e site, sobre sistemas open source. Planos, prazos e como funciona a implantação."
      canonicalUrl="/automacao-empresarial"
    />
    <NavbarNew />

    <main>
      <section className={`${container} pb-10 pt-16`}>
        <Link
          to="/servicos"
          className="text-[13px] font-semibold text-muted-foreground transition-colors hover:text-foreground"
        >
          ← Todos os serviços
        </Link>
        <h1 className="mt-[18px] max-w-[760px] text-[50px] font-bold leading-[1.08] tracking-[-0.04em] max-[900px]:text-[36px]">
          Automação com IA nos pontos onde sua empresa perde cliente
        </h1>
        <p className="mt-[18px] max-w-[600px] text-[17px] leading-[1.65] text-muted-foreground">
          Implanto sistemas open source configurados para o seu processo e conecto IA onde o lead
          esfria e o cliente espera. Em 30 dias rodando, sem trocar o que você já usa.
        </p>
      </section>

      <section className={`${container} pb-16`}>
        <h2 className="mb-[18px] text-[13px] font-bold uppercase tracking-[0.07em] text-muted-foreground">
          Escolha a solução
        </h2>
        <PillarCards />
      </section>

      <AutomacaoPricingSection subtitle="Os mesmos planos valem para cada solução. Faixa fechada depois do diagnóstico." />

      <AutomacaoStepsSection className="border-0 bg-background" />

      <AutomacaoFaqSection className="pt-0" />

      <section className={`${container} pb-[90px]`}>
        <div className="relative isolate flex flex-wrap items-center justify-between gap-6 overflow-hidden rounded-3xl bg-deep px-11 py-[52px] text-deep-foreground max-[900px]:px-6">
          <div className="absolute inset-0 -z-10">
            <Photo id="caixa-loja" decorative sizes="(max-width: 900px) 100vw, 1120px" />
            <div className="absolute inset-0 bg-gradient-to-r from-deep via-deep/[0.92] to-deep/80" />
          </div>
          <div className="max-w-[560px]">
            <h2 className="text-[31px] font-bold tracking-[-0.03em]">
              Não sabe se começa pelo CRM ou pelo atendimento?
            </h2>
            <p className="mt-3.5 text-[15.5px] leading-[1.65] text-white/70">
              No diagnóstico gratuito eu olho onde você perde mais e digo por onde começar.
            </p>
          </div>
          <Link
            to="/contato"
            className="inline-flex h-[52px] items-center rounded-full bg-white px-[30px] text-[15px] font-bold text-primary-deep transition hover:brightness-[.94]"
          >
            Agendar diagnóstico gratuito
          </Link>
        </div>
      </section>
    </main>

    <FooterNew />
  </div>
);

export default AutomacaoHub;
